export default __webpack_public_path__ + "static/airbubbles-312513474afccf7f43124a55186f18a4.png";